<template>
  <b-form
    class="input-password-form custom-input-form preview"
    aria-live="assertive"
    @submit.prevent="onSubmit"
  >
    <div class="login">
      <label for="login-email" class="text-muted">{{ $t('form.login') }}</label>
      <b-form-input
        id="login-email"
        v-model.trim="form.email"
        name="login-email"
        :state="validateState('email')"
        aria-describedby="input-email-feedback"
        :placeholder="$t('form.email.label')"
        class="custom-form-input custom-form-input-class text-muted"
        @blur="onBlur('email')"
      ></b-form-input>
      <b-form-invalid-feedback id="input-email-feedback">
        {{ $t('message.error.invalidEmail') }}
      </b-form-invalid-feedback>
    </div>

    <div class="pwd my-4">
      <div class="d-flex justify-content-between">
        <label for="login-pass" class="text-muted">{{ $t('form.password.label') }}</label>
        <router-link :to="{ name: 'ResetPassword' }" class="text-primary">
          {{ $t('login.form.forgotPwd') }}
        </router-link>
      </div>

      <b-input-group>
        <b-form-input
          id="login-pass"
          v-model="form.password"
          :type="passwordFieldType"
          name="login-pass"
          :state="validateState('password')"
          aria-describedby="input-password-feedback"
          :placeholder="$t('form.password.label')"
          class="custom-form-input custom-form-input-class text-muted"
          @blur="onBlur('password')"
        ></b-form-input>
        <b-input-group-append>
          <b-button class="preview-icon d-flex align-items-center" @click="showPwd">
            <svg-icon
              v-show="!showPassword"
              class="fill-icon show-icon"
              name="close-eye"
              size="20"
            ></svg-icon>
            <svg-icon
              v-show="showPassword"
              class="fill-icon show-icon"
              name="open-eye"
              size="20"
            ></svg-icon>
          </b-button>
        </b-input-group-append>
        <b-form-invalid-feedback id="input-email-feedback">
          {{ $t('message.error.requiredField') }}
        </b-form-invalid-feedback>
      </b-input-group>
    </div>

    <b-form-group>
      <b-form-checkbox
        id="login-keep-signed"
        v-model="form.keepSigned"
        name="login-keep-signed"
        class="custom-koeebox-checkbox"
      >
        <i class="input-helper text-warning"></i>
        {{ $t('login.form.keepSigned.label') }}
      </b-form-checkbox>
    </b-form-group>

    <div class="margin-top-30">
      <b-button
        type="submit"
        class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
        :disabled="processing"
        variant="primary"
      >
        <p v-if="!processing">{{ $t('button.login.label') }}</p>
        <div v-if="processing">
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </div>
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const validateEmail = (email) => {
  let re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export default {
  name: 'SmartOeeLoginForm',
  data() {
    return {
      showPassword: false,
      passwordFieldType: 'password',
      form: {
        email: '',
        password: '',
        keepSigned: false,
      },
      valid: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        validateEmail,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    error() {
      return this.$store.getters.getError;
    },
    processing() {
      return this.$store.getters.getProcessing;
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  watch: {
    isUserAuthenticated(val) {
      if (val) {
        this.$routerCore.GoToHomePage();
      }
    },
  },
  mounted() {
    if (this.$authCore.isAuthenticated) {
      this.$routerCore.GoToHomePage();
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    showPwd() {
      this.showPassword = !this.showPassword;
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    onBlur(name) {
      this.$v.form[name].$touch();
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$authCore.SignIn({
        email: this.form.email.toLowerCase().trim(),
        password: this.form.password,
        keepSigned: this.form.keepSigned,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
